import { Client } from "@/Common/Api/Client";

interface DsqImportModel {
    PatientContactId: string;
    SILID: string;
    SILOID: string;
    ReportTypes: any[];
    Category: string;
    HasNewItemInHistory?: boolean;
}

class DSQHelper {
    // ----------------------DSQ import----------------------
    public static postImportDSQ(operation: number, rq: DsqImportModel, stopLoading: void, handlerOverload: (response: any) => void = null): boolean {
        if (handlerOverload != null)
            Client.PostDSQ(operation, rq, handlerOverload);
        else
            Client.PostDSQ(
                operation,
                rq,
                response => {
                    stopLoading;

                    if (response == null)
                        return true;

                    if (response.Errors && response.Errors.length) {
                        sessionStore.showPopup(response.Errors);
                        return true;
                    }
                }
            );

        return false;
    }
}

export { DSQHelper, DsqImportModel };
